import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SuperhogDashboard } from 'models';
import { SuperhogService } from 'services';

@Injectable({
    providedIn: 'root'
})
export class SuperhogResolver implements Resolve<SuperhogDashboard> {
    constructor(private superhogService: SuperhogService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<SuperhogDashboard> {
        return this.superhogService.get();
    }
}
